(() => {
  if (window.SunlitProductCardFixesLoaded) return;
  window.SunlitProductCardFixesLoaded = true;

  const selectors = {
    recommendations: 'product-recommendations',
    productForm: 'product-form-component',
    addButton: 'button[name="add"], .quick-add__button--add',
  };

  function getCartSectionIds() {
    return Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
      .map((element) => element.dataset.sectionId)
      .filter(Boolean)
      .filter((value, index, array) => array.indexOf(value) === index);
  }

  function dispatchCartUpdate(parsedResponse, variantId) {
    const sections = parsedResponse && parsedResponse.sections ? parsedResponse.sections : {};
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: parsedResponse,
          data: {
            source: 'sunlit-product-card-fix',
            variantId: variantId ? String(variantId) : undefined,
            itemCount: parsedResponse && parsedResponse.item_count,
            sections,
          },
        },
      })
    );
  }

  function setButtonBusy(button, busy) {
    if (!button) return;
    button.disabled = busy;
    button.classList.toggle('is-loading', busy);
    button.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  async function addRecommendationForm(form, triggerButton) {
    const variantInput = form.querySelector('input[name="id"]');
    const variantId = variantInput && variantInput.value;
    if (!variantId || variantInput.disabled) return false;

    const formData = new FormData(form);
    const sectionIds = getCartSectionIds();
    if (sectionIds.length) {
      formData.set('sections', sectionIds.join(','));
      formData.set('sections_url', window.location.pathname);
    }

    setButtonBusy(triggerButton, true);
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        body: formData,
      });
      const parsed = await response.json().catch(() => ({}));
      if (!response.ok || parsed.status >= 400) {
        throw new Error(parsed.description || parsed.message || 'Could not add this item.');
      }
      triggerButton?.classList.add('atc-added');
      dispatchCartUpdate(parsed, variantId);
      window.setTimeout(() => triggerButton?.classList.remove('atc-added'), 1800);
      return true;
    } finally {
      window.setTimeout(() => setButtonBusy(triggerButton, false), 350);
    }
  }

  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      const recommendations = form.closest(selectors.recommendations);
      if (!recommendations) return;
      const productForm = form.closest(selectors.productForm);
      if (!productForm) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      try {
        await addRecommendationForm(form, form.querySelector(selectors.addButton));
      } catch (error) {
        console.error('Sunlit recommendation add failed:', error);
        const liveRegion = productForm.querySelector('[ref="liveRegion"]');
        if (liveRegion) liveRegion.textContent = error.message || 'Could not add this item.';
      }
    },
    true
  );
})();
